import moment from 'moment'

export const formatBatch = batch => {
    return `${moment(batch).format('YYYY')}-${moment(batch)
        .add(2, 'years')
        .format('YYYY')}`
}
